<sia-pdf-viewer [file]="file"></sia-pdf-viewer>
